<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md class="subnav__semi-reduced-padding">
    <sbnb-back-button></sbnb-back-button>

    <sbnb-helptext-wrapper [area]="'sidebar'" [pageId]="'ops-log-detail'"></sbnb-helptext-wrapper>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <div *ngIf="loading" class="table__no-items">Loading log details...</div>

    <ng-container *ngIf="!loading && logData">
      <app-feature-flag-tabs>
        <sbnb-page-header navTabs class="absolute"></sbnb-page-header>
      </app-feature-flag-tabs>

      <div
        fxLayout
        fxLayout.lt-md="column"
        fxLayoutAlign.lt-md="center end"
        fxlayoutAlign="space-between center"
        class="log__top-container">
        <div fxFlex fxLayout fxLayoutGap="12px" fxLayoutAlign="start center">
          <img
            *ngIf="logData.status === logStatus.Scheduled"
            [matTooltip]="'Scheduled for: ' + logData.scheduled_for_label"
            src="/assets/iconography/nav-rule-manager.svg" />
          <sbnb-icon
            *ngIf="logData.status === logStatus.Sent"
            icon="check"
            class="grass-darker"
            [matTooltip]="'Sent at: ' + logData.scheduled_for_label"></sbnb-icon>
          <img
            *ngIf="logData.status === logStatus.Bounced"
            [matTooltip]="'Bounced'"
            src="/assets/iconography/delete.svg" />
          <img
            *ngIf="logData.status === logStatus.Cancelled || logData.status === logStatus.Failed"
            src="/assets/iconography/delete.svg" />
          <h2 class="nomargin">{{ logData.ruleset }}</h2>
          <span class="text__xsmall log__reservation-code">{{ logData.confirmation_code }}</span>
        </div>

        <div fxLayout fxLayoutGap="12px">
          <button
            [disabled]="cancelling"
            *ngIf="logData.status === logStatus.Scheduled"
            class="button__small button__secondary"
            mat-flat-button
            (click)="cancelNotification()">
            <span>Cancel this notification</span>
            <mat-spinner *ngIf="cancelling" diameter="16" class="button__spinner"></mat-spinner>
          </button>
          <button class="button__small" mat-flat-button (click)="reportProblem()">Report a problem</button>
        </div>
      </div>

      <div *ngFor="let attr of logData.attributes; let i = index" class="log__section" fxLayout fxLayoutGap="16px">
        <strong fxFlex="30">{{ attr.label }}</strong>

        <div *ngIf="attr.type === 'user'" fxFlex fxLayout fxLayoutGap="12px" fxLayoutAlign="start center">
          {{ attr.name }}
        </div>

        <div *ngIf="attr.type === 'text'" fxFlex>{{ attr.text }}</div>

        <div *ngIf="attr.type === 'message'" fxFlex>
          <div
            *ngIf="!editMessageMode"
            [innerHTML]="
              attr.text === 'DELETE' ? 'This message was deleted and no notification will be sent' : (attr.text | nl2br)
            "></div>
          <button
            *ngIf="!editMessageMode && !logData.sent && !logData.cancelled"
            class="button__small message__button"
            mat-flat-button
            (click)="editMessageMode = true; newMessage = attr.text">
            Edit Message
          </button>

          <textarea
            *ngIf="editMessageMode"
            matInput
            [(ngModel)]="newMessage"
            placeholder="The message we will send to your teamamte"
            class="message__textarea"></textarea>

          <div *ngIf="editMessageMode" fxLayout fxLayoutGap="12px">
            <button
              [disabled]="updating"
              class="button__small button__secondary message__button"
              mat-flat-button
              (click)="editMessageMode = false; newMessage = null">
              Cancel
            </button>
            <button
              [disabled]="updating"
              class="button__small message__button"
              mat-flat-button
              (click)="updateLog(attr)">
              <span>Save</span>
              <mat-spinner *ngIf="updating" diameter="16" class="button__spinner"></mat-spinner>
            </button>
          </div>
        </div>

        <div *ngIf="attr.type === 'rule'" fxFlex>
          The notification rule
          <a class="ocean clickable strong" [routerLink]="['/operations/notifications/detail/' + attr.ruleset_id]">
            {{ attr.name }}
          </a>
          was active
        </div>

        <div *ngIf="attr.type === 'text-link'" fxFlex>
          <a class="ocean strong" [href]="attr.link" target="_blank">{{ attr.text }}</a>
        </div>
      </div>
    </ng-container>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Operations'">
  <sbnb-operations-subnav></sbnb-operations-subnav>
</sbnb-mobile-sidebar>
